import {
  BaseCarouselProps,
  CarouselBase,
  IProps as CarouselBaseIProps,
} from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Carousel/CarouselBase";
import { SmallProductTile } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Components/SmallProductTile";
import { Context } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Context";
import { ILeanProductWithBrandTile } from "@faire/retailer-visitor-shared/lib/ILeanProductWithBrandTile";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { ILayoutElementData } from "@faire/web-api--source/indigofair/data/ILayoutElementData";
import React from "react";

export const SmallProductTileCarousel: React.FC<BaseCarouselProps> = (
  props
) => {
  const { strictLocalize } = useStrictLocalization();
  const { layoutElement, requestId, onVisible } = React.useContext(Context);

  const renderItem = (data: ILayoutElementData) => {
    const tile = ILeanProductWithBrandTile.fromLayoutElementData(
      data,
      strictLocalize
    );

    if (!tile || !tile.product || !tile.brand) {
      return null;
    }

    return (
      <SmallProductTile
        key={tile.product?.product?.token}
        product={tile.product}
        brand={tile.brand}
      />
    );
  };

  const getItems = () => {
    return layoutElement.layout_element_data.filter(isNotUndefined);
  };

  const onItemsVisible = (items: ILayoutElementData[]) => {
    const itemTokens = items.map((item) => {
      const tile = ILeanProductWithBrandTile.fromLayoutElementData(
        item,
        strictLocalize
      );
      return tile?.product?.product?.token;
    });
    if (layoutElement.on_click_event_name) {
      onVisible?.(
        layoutElement.on_click_event_name,
        requestId,
        itemTokens?.join(" ") ?? ""
      );
    }
  };

  return (
    <CarouselBaseComponent
      renderItem={renderItem}
      itemsPerSlide={{
        mobileAndAbove: 2,
        tabletAndAbove: 6,
        xLargeAndAbove: 8,
      }}
      items={getItems()}
      peekNextPercent={{
        mobileAndAbove: 40,
        tabletAndAbove: 0,
      }}
      lateralPadding={16}
      onItemsVisible={onItemsVisible}
      {...props}
    />
  );
};

const CarouselBaseComponent = CarouselBase as React.ComponentType<
  CarouselBaseIProps<ILayoutElementData>
>;
